<div class="column-grid tw-gap-2 tw-mb-2 tw-justify-start tw-place-items-center">
  <span class="tw-font-bold {{requirementStatusClass()}}">
      {{ requirement.year }}
  </span>
  <ng-container *ngIf="!documentStateLoading() else loading">

    <span interactive *ngIf="requirement.documentData else missingBusinessDoc"
          tooltipIfClamped
          [matTooltip]="requirement.documentData.title"
          [matMenuTriggerFor]="menu"
          class="!tw-mb-0 tw-whitespace-nowrap tw-overflow-ellipsis tw-overflow-hidden tw-max-w-full !tw-cursor-pointer">
              {{ requirement.documentData.title }}
    </span>

  </ng-container>
</div>

@if (requirement.documentData && !documentStateLoading()) {
  <div class="column-grid tw-gap-2 tw-justify-start tw-place-items-center">

    <span class="tw-font-bold">FlashSpread status: </span>
    @if(flashSpreadStatus()) {
      <span>{{flashSpreadStatus()}}</span>
    } @else {
      <span>Not pushed</span>
      <div>
        <button mat-stroked-button
                [color]="'primary'"
                [matTooltip]="'Push Document to FlashSpread'"
                (click)="pushDocumentToFlashSpread(requirement.documentData.id)">
          Push
        </button>
      </div>
    }

  </div>
}

<ng-template #missingBusinessDoc>

  <button
    mat-flat-button
    [color]="'primary'"
    class="tw-ml-2 lendio-density-2"
    [matMenuTriggerFor]="menu"
    data-cy="add-document-category">
    Assign / Upload
  </button>

</ng-template>

<mat-menu
  [class]="'!tw-w-[350px] !tw-max-w-[350px] !tw-max-h-[50vh]'"
  #menu="matMenu">

  <div mat-menu-item>
    <app-document-upload-button [uploadCallback]="handleUpload" />
  </div>
  <mat-divider/>

  <ng-container *ngIf="!!ownerDocumentsWithNoYear?.length">
    <h2 class="tw-pl-4 tw-pt-2 !tw-mb-0">Owner Documents with no Year:</h2>
    <button
      *ngFor="let document of contact.ownerDocumentsWithNoYear"
      mat-menu-item
      (click)="assignDocumentToRequirement(document)">
      <div tooltipIfClamped [matTooltip]="document.filename" class="tw-whitespace-nowrap">
        {{document.filename}}
      </div>
    </button>
    <mat-divider/>
  </ng-container>
  <h2 class="tw-pl-4 tw-pt-2 !tw-mb-0">Borrower Documents:</h2>
  <button
    *ngFor="let document of borrowerDocuments"
    mat-menu-item
    (click)="assignDocumentToRequirement(document)">
    <div tooltipIfClamped [matTooltip]="document.filename" class="tw-whitespace-nowrap">
      {{document.filename}}
    </div>
  </button>

</mat-menu>

<ng-template #loading>
  <mat-spinner [diameter]="24"/>
</ng-template>
